import gql from "graphql-tag";
import graphqlClient, { fragments } from "@/http/graphql/inside";

const ADD_COMMENT = `
	comment(content: $content, post_id: $post_id, model: $model, attachs: $attachs) {
		...Comment
	}
`;

const GET_COMMENTS = `
	comments (limit: $limit, page: $page, post_id: $post_id, model: $model) {
		...Comments
	}
`;

export default {
	init() {},

	addComment(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation CommentManagementCreateComment (
					$post_id: Int!,
					$content: String!,
					$model: String,
					$attachs:[Int]
				) {
					${ADD_COMMENT}
				}
				${fragments.Comment}
				`,
				variables: {
					post_id: payload.post_id,
					content: payload.content.content,
					model: payload.model,
					attachs: payload.content.attachs
				}
			})
			.then(response => response.data.comment);
	},

	getComments(payload) {
		return graphqlClient
			.query({
				query: gql`query CommentManagementGetCommentsByModel ($limit: Int!, $page: Int!, $post_id: Int!, $model: String) {
					${GET_COMMENTS}
				}
				${fragments.Comments}
			`,
				variables: {
					limit: payload.limit || 5,
					page: payload.page || 5,
					post_id: payload.post_id,
					model: payload.model
				}
			})
			.then(response => response.data.comments);
	},
};
